export const ReportData = `<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M11 6H7C6.44772 6 6 6.44772 6 7V28C6 28.5523 6.44772 29 7 29H25C25.5523 29 26 28.5523 26 28V7C26 6.44772 25.5523 6 25 6H21" stroke="currentColor" stroke-width="2"/>
  <path d="M21 9H11V4C11 3.44772 11.4477 3 12 3H20C20.5523 3 21 3.44772 21 4V9Z" stroke="currentColor" stroke-width="2"/>
  <path d="M21 24V18" stroke="currentColor" stroke-width="2"/>
  <path d="M11 24L11 14" stroke="currentColor" stroke-width="2"/>
  <path d="M16 24L16 20" stroke="currentColor" stroke-width="2"/>
</svg>`;
